import { makeStyles, withStyles, Tooltip } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "@themes";

export const GeneralStyle = styled.div`
  .MuiTabs-scroller.MuiTabs-fixed {
    margin-left: 1.5rem;
  }
  .MuiPaper-root {
    margin-bottom: 17px;
    margin-left: 2%;
    border-bottom: 2px solid ${({ theme }) => theme.neutral.gray[300]};
    width: 96%;
    box-shadow: none;
  }
  .MuiTableCell-root {
    padding: 12px;
  }
`;

export const CardsWrapperUsers = styled.div`
  user-select: none;
  .MuiIconButton-colorInherit {
    border-radius: 0px;
    margin-right: 0px;
    padding: 0px;
    height: 1.7em;
  }
  .MuiIcon-colorPrimary {
    color: ${({ theme }) => theme.primary.purple};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: none;
  }
  .MuiIcon-colorSecondary {
    color: ${({ theme }) => theme.neutral.gray[3300]};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ContentTable = styled.div`
  overflow: auto;
  .MuiPaper-elevation2 {
    z-index: 0;
  }
  .MuiPaper-root {
    background-color: ${({ theme }) => theme.background.light};
  }
  .MuiTableCell-alignLeft {
    text-align: center;
  }
  .MuiFormControlLabel-root {
    margin: 0;
  }
  th {
    background-color: ${({ theme }) => theme.background.light};
  }
  th > span {
    height: 35px;
  }
`;

export const Convention = styled.div`
  display: flex;
  width: 50%;
  align-items: center;
  justify-content: flex-start;
  p {
    margin: 0 1em 0 0.4em;
  }
`;
export const ContentFilters = styled.div`
  z-index: 1;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: fit-content;
  margin: 15px 1rem;
  animation: scale-up-hor-left 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  @keyframes scale-up-hor-left {
    0% {
      transform: scaleX(0.5);
      transform-origin: 0% 0%;
    }
    100% {
      transform: scaleX(1);
      transform-origin: 0% 0%;
    }
  }
`;

export const ContentButtonSeeDetails = styled.div`
  button {
    border-style: none;
    background: ${({ theme }) => theme.button.primary};
    border-radius: 5px;
    width: 3em;
    height: 1.7em;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: ${({ theme }) => theme.button.primaryHover};
      box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }
  }
  svg {
    fill: white;
    font-size: 17px;
    display: flex;
    float: right;
  }
`;
export const ContentRegistered = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 20px;
  svg {
    margin-left: 5px;
    cursor: pointer;
  }
`;

export const ContentLoader = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
`;
export const DetailContainer = styled.div`
  z-index: 0;
  position: relative;
  margin-top: 1%;
  width: 98%;
  margin-left: 1%;
  th {
    background-color: ${({ theme }) => theme.neutral.gray[800]} !important;
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
`;
export const TableViewButton = styled.div`
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 1px;
  background: ${({ theme }) => theme.neutral.white};
  width: 40px;
  height: 40px;
  .filter-list-icon {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
  .list-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.text.primary : theme.tabs.selected)};
  }
  .card-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
`;

export const ActionSection = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto 9fr auto;
  @media only screen and (min-width: 769px) {
    grid-template-columns: auto 9fr auto;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    grid-template-columns: auto 9fr auto;
  }
  @media only screen and (max-width: 480px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .right-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .table-action {
    margin-right: 20px;
  }
`;

export const ContentFilterButton = styled.div`
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 1px;
  background: ${({ theme }) => theme.neutral.white};
  width: 6em;
  height: 4em;
  margin: 0.5em 0px 0px 0px;
  align-items: center;
  display: flex;
  justify-content: center;
  .filter-list-icon {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
  &:hover {
    cursor: pointer;
    border-top: 1px solid
      ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
`;
export const ModaContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ModalContent = styled.div`
  width: 80%;
  max-width: 880px;
  height: 100vh;
  max-height: 650px;
  background-color: ${({ theme }) => theme.neutral.gray[800]};
  display: grid;
  grid-template-columns: 30% 70%;
`;
export const TemplateContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const PreviewContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;
export const PercentLabel = styled.label`
  font-weight: 600;
  color: ${({ value, theme }) => {
    if (value < 50) {
      //grey color upto 49
      return theme.neutral.gray[2600];
    } else if (value >= 50 && value < 75) {
      //purple for 50 to 74
      return theme.tabs.selected;
    }
    //green for 75 and above
    return theme.primary.greenDark;
  }};
`;

export const ActionsContainer = styled.div`
  display: flex;
`;

export const useStyles = makeStyles(() => ({
  active: {
    "& svg": {
      color: theme.tabs.selected,
    },
    "&:disabled svg": {
      color: theme.neutral.gray[500],
    },
  },
  delete: {
    color: theme.status.error,
  },
  buttonActive: () => ({
    background: theme.button.primary,
    color: "white",
    height: "29px",
    padding: "3px 10px",
    fontSize: "12px",
  }),
  tabs: {
    backgroundColor: theme.neutral.white,
  },
}));

export const HtmlTooltip = withStyles(() => ({
  tooltip: {
    pointerEvents: "auto",
    backgroundColor: "white",
    margin: "9 0",
    color: theme.neutral.gray[2500],
    border: "1px solid #dadde9",
    boxShadow: "4px 4px #92929236",
  },
}))(Tooltip);

export const SearchField = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  background: ${({ theme }) => theme.neutral.white};
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  max-width: 190px;
  margin-right: 20px;
  svg {
    position: absolute;
  }
  input {
    font-size: 12px;
    font-weight: 400;
    border: none;
    outline: none;
    width: 85%;
    box-shadow: none;
    margin-left: 2rem;
    padding-right: 1rem;
  }
  input:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  input::placeholder {
    color: #989898;
  }
`;
